export const APP_BOOTSTRAP = 'app.bootstrap';
export const APP_BOOTING = 'app.booting';
export const APP_BOOTED = 'app.booted';

export const APP_LOAD_INIT_VALUES = 'app.load-init-values';

export const APP_LOAD_REQUIRES = 'app.load-requires';
export const APP_LOADING = 'app.loading';
export const APP_LOADED = 'app.loaded';

export const APP_SET_FATAL_ERROR = 'app.set-fatal-error';
export const APP_CLEAR_FATAL_ERROR = 'app.clear-fatal-error';

export const APP_SET_WORK_SCHEDULE = 'app.set-work-schedule';
